// extracted by mini-css-extract-plugin
module.exports = {"submit":"submit-step_submit__3RqFZ","textButton":"submit-step_textButton__V7Etc","back":"submit-step_back__3z9yS","submitButton":"submit-step_submitButton__1VeUa"};